// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Gcc8","content":"styles_content__2Ajay","selectAll":"styles_selectAll__iCih3"};